import { Pipe, PipeTransform } from '@angular/core';
import { Stations } from 'src/app/services/stations/stations';

@Pipe({
  name: 'filterStations'
})
export class FilterStationsPipe implements PipeTransform {

  transform(items: Stations[], searchText: string): any[] {
    // console.log(items)
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => it.stationName.toLowerCase().includes(searchText));
}

}
